import { useApiClient } from '../client.js'

export const GET_EXPERINEMT_BUSINESS_VARIANTS_ENDPOINT = '/core/v2/business_api/me/businesses/{businessId}/experiment_variant/{experimentName}/'

export function getExperimentVariant (businessId, experimentName) {
  const apiClient = useApiClient()

  return apiClient.get({
    url: GET_EXPERINEMT_BUSINESS_VARIANTS_ENDPOINT,
    urlParams: {
      businessId,
      experimentName,
    },
  })
}
